import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "linkedin-logo",
  "use": "linkedin-logo-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" id=\"linkedin-logo\"><path d=\"M21.995 21H22v-7.503C22 9.827 21.223 7 17.004 7c-2.028 0-3.39 1.132-3.945 2.205H13V7.343H9v13.656h4.165v-6.762c0-1.78.332-3.502 2.5-3.502 2.137 0 2.169 2.032 2.169 3.616V21h4.161zM1 7h5v14H1V7zM3.5 0C2.12 0 1 1.115 1 2.488 1 3.862 2.12 5 3.5 5S6 3.862 6 2.488A2.496 2.496 0 003.5 0z\" /></symbol>"
});
var result = sprite.add(symbol);
export default "#" + symbol.id